import type { ComparePlansTableRow } from './types';

// flag-OFF fallback only: useComparePlansTable derives rows from each offer's
// `features` array when the catalog API is on. Kept for the hardcoded catalog, which has no
// per-feature availability data. Black "Assinatura digital" is "60/mês" (newTierBenefits), not
// "Ilimitado".
export const COMPARE_PLANS_TABLE_ROWS: ComparePlansTableRow[] = [
  {
    attribute: 'IA da Jusfy',
    values: { one: '20 mensagens', ultimate_2026: '150 mensagens', black: 'Ilimitado' },
  },
  {
    attribute: 'Consultas jurídicas',
    values: { one: '5', ultimate_2026: '20', black: '60' },
  },
  {
    attribute: 'Cálculos jurídicos',
    values: { one: '5', ultimate_2026: '20', black: 'Ilimitado' },
  },
  {
    attribute: 'Assinatura digital',
    values: { one: '5', ultimate_2026: '20', black: '60/mês' },
  },
  {
    attribute: 'Oportunidades de prospecção',
    values: { one: '5', ultimate_2026: '20', black: '40' },
  },
  {
    attribute: 'Monitoramento de processos',
    values: { one: 'Ilimitado', ultimate_2026: 'Ilimitado', black: 'Ilimitado' },
  },
  {
    attribute: 'Modelos de petição',
    values: { one: 'Ilimitado', ultimate_2026: 'Ilimitado', black: 'Ilimitado' },
  },
  {
    attribute: 'Subusuários',
    values: { one: '—', ultimate_2026: '3', black: '5' },
  },
  {
    attribute: 'E-mail profissional',
    values: { one: '—', ultimate_2026: 'Add-on', black: 'Incluso' },
  },
  {
    attribute: 'Site personalizado',
    values: { one: '—', ultimate_2026: 'Incluso', black: 'Incluso' },
  },
];
